import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../utils/userProvider";
import axios from "axios";

export default function useSundries() {
    const backend_url = `${process.env.REACT_APP_BACKEND_URL}/sundries`;
    const { authState, setAuthState } = useContext(AuthContext);
    const [res, setRes] = useState({
        data: null,
        complete: false,
        loading: false,
        error: false,
    });

    const [resetCount, setResetCount] = useState(0);

    const reset = () => {
        var newResetCount = resetCount + 1;
        setResetCount(newResetCount);
    };

    useEffect(() => {
        setRes({
            data: null,
            loading: true,
            error: false,
            complete: false,
        });
        axios({
            url: backend_url,
            method: "GET",
            headers: {
                Authorization: `Bearer ${authState.jwt ? authState.jwt : ""}`,
            },
        })
            .then((res) =>
                setRes({
                    data: res.data,
                    loading: false,
                    error: false,
                    complete: true,
                })
            )
            .catch((e) =>
                setRes({
                    data: null,
                    loading: false,
                    error: true,
                    errorMessage: e.response,
                    complete: true,
                })
            );
    }, [resetCount]);

    return [res, reset];
}
